module.exports = __webpack_public_path__ + "static/img/basico.d839af82.jpg";